import {
  SELECT_RECOMMENDATION,
  SELECT_IMMUNIZATION,
  SELECT_PATHOLOGY,
  REMOVE_SELECTED_RECOMMENDATION,
  REMOVE_SELECTED_IMMUNIZATION,
  SELECT_EMPTY_INSERTION,
  REMOVE_EMPTY_INSERTION,
  REMOVE_SELECTED_PATHOLOGY,
  REMOVE_CURRENT_SELECTIONS,
  SELECT_PREVIOUS_INSERTION,
  REMOVE_PREVIOUS_INSERTION
} from './types'

const currentSelection = (state = {}, action) => {
  switch (action.type) {
    case SELECT_PATHOLOGY:
      return Object.assign({}, state, {
        pathology: action.payload
      })
    case REMOVE_SELECTED_PATHOLOGY :
      return Object.assign({}, state, {
        pathology: undefined
      })
    case SELECT_IMMUNIZATION:
      return Object.assign({}, state, {
        immunization: action.payload,
        insertionType: undefined
      })
    case REMOVE_SELECTED_IMMUNIZATION:
      return Object.assign({}, state, {
        immunization: undefined
      })
    case SELECT_RECOMMENDATION:
      return Object.assign({}, state, {
        recommendation: action.payload,
        insertionType: undefined
      })
    case REMOVE_SELECTED_RECOMMENDATION:
      return Object.assign({}, state, {
        recommendation: undefined
      })
    case SELECT_EMPTY_INSERTION:
      return Object.assign({}, state, {
        pathology: undefined,
        insertionType: action.payload
      })
    case REMOVE_EMPTY_INSERTION:
      return Object.assign({}, state, {
        insertionType: undefined
      })
    case SELECT_PREVIOUS_INSERTION:
      return Object.assign({}, state, {
        pathology: undefined,
        insertionType: action.payload
      })
    case REMOVE_PREVIOUS_INSERTION:
      return Object.assign({}, state, {
        insertionType: undefined
      })
    case REMOVE_CURRENT_SELECTIONS:
      return Object.assign({}, state, {
        immunization: undefined,
        recommendation: undefined,
        pathology: undefined,
        insertionType: undefined
      })

    default:
      return state
  }
}

export default currentSelection
